import type { MailboxInfo } from 'owa-client-types';
import { getAsyncItemRegistry } from './getAsyncItemRegistry';
import type { SeedStatus } from '../store/schema/AsyncItemRegistry';

export function getSeedStatus(mailboxInfo: MailboxInfo): SeedStatus {
    return getAsyncItemRegistry(mailboxInfo)?.seedStatus ?? 'notSeeded';
}
